export default {
  parts: ['container', 'track', 'thumb'],
  baseStyle: {
    track: {
      bg: 'secondary.300',
      '&[data-checked]': {
        bg: 'primary.400',
        '&:hover': {
          bg: 'primary.400',
        },
      },
      '&[data-disabled][data-checked]': {
        bg: 'primary.500',
        opacity: 0.5,
      },
      '&[data-disabled]': {
        opacity: 0.5,
      },
    },
  },
  defaultProps: {
    size: 'lg',
  },
};
